export default class   Corte {
    constructor(
        public codCuenta?: string  ,
        public periodo?: string  ,
        public fechaDesde?: string  ,
        public fechaHasta?: string  ,
        public nroLot?: string  ,
        public titulo?:string,
        public fileName?:string

    ){}
}